import React, { useContext, useEffect } from "react";
import CardDiv from "modules/common/card-div/CardDiv";
import { ProgressBar } from "react-bootstrap";
import { Button } from "antd";
import { isEmpty } from "lodash";
import { DownloadOutlined } from "@ant-design/icons";
import { FeedbackDate } from "./FeedbackTab";
import { useFemaleFeedback } from "./store";
import moment from "moment";
import xlsx from "json-as-xlsx";

function FemaleSurveyPlan({ femaleRatingData, planLength }) {
  const { startDate, endDate } = useContext(FeedbackDate);
  const {femaleDownloadData, femaleDownloadLoading, fetchFemaleFeedbackDownload} = useFemaleFeedback();

  useEffect(()=>{
    fetchFemaleFeedbackDownload(startDate.valueOf(), endDate.valueOf());
  },[startDate])


  const ExcelDownload = (excelData) => {
    const _data = excelData?.map((el) => {
      let hairIssue = "";
      el?.hair_problem.forEach((item)=>{
        hairIssue+=item+'/' ;
      })

      return {
        ...el,
        userName: el.user ? el.user?.first_name : "",
        userPhoneNumber: el.user ? el.user?.phone_number : "",
        userGender: el.user ? el.user?.gender : "",
        userEmail: el.user ? el.user?.email : "",
        satisfied: el.satisfaction? el?.satisfaction:"",
        trayaConditioner: el.traya_conditioner?el.traya_conditioner:"",
        currentConditioner: el.current_conditioner?el.current_conditioner:"",
        hairProblem: el.hair_problem?hairIssue: "" ,
        reasonablePrice : el.reasonable_price_range?el.reasonable_price_range:"",
        additionalComment:el.additional_comment?el?.additional_comment: "",
        updatedAt: moment(el.updatedAt).format("DD-MM-YYYY HH:mm:ss"),
        createdAt: moment(el.createdAt).format("DD-MM-YYYY HH:mm:ss"),
      };
    });
    const data = [
      {
        sheet: "deliveryFeedbacks",
        columns: [
          { label: "Case Id", value: "case_id" },
          { label: "Customer Name", value: "userName" },
          { label: "Customer Phone Number", value: "userPhoneNumber" },
          { label: "Customer Email Id", value: "userEmail" },
          { label: "Customer Gender", value: "userGender" },
          { label: "Customer Satisfaction", value: "satisfied" },
          { label: "Customer Using Traya Conditioner", value: "trayaConditioner" },
          { label: "Customer Current Conditioner", value: "currentConditioner" },
          { label: "Customer Hair Problem", value: "hairProblem" },
          { label: "Reasonable Price Range", value: "reasonablePrice" },
          { label: "Additional Comment", value: "additionalComment" },
          {
            label: "Created At",
            value: "createdAt",
          },
          {
            label: "Updated At",
            value: "updatedAt",
          },
        ],
        content: _data,
      },
    ];

    let settings = {
      fileName: `Delivery Feedbacks`,
      extraLength: 3,
      writeMode: "writeFile",
      writeOptions: {},
    };
    xlsx(data, settings);
  };

  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between align-items-center my-n2">
          <div className="d-flex flex-row gap-4">
            <div className="">Rating of Customer Satisfied With Traya</div>
            <div className="d-flex gap-2">
              <div className="fw-bold">Total Count:</div>
              <div className="fw-bold">{planLength || "0"}</div>
            </div>
          </div>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
              onClick={() => ExcelDownload(femaleDownloadData?.feedbacks)}
            disabled={isEmpty(femaleDownloadData?.feedbacks)}
          >
            Download
          </Button>
        </div>
      }
      component={
        <div className="d-flex gap-2">
          <div className="mt-n2 w-75">
            <div className="d-flex align-items-center gap-3">
              <div style={{ marginLeft: "4.5rem" }}>Neutral:</div>
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+femaleRatingData?.Neutral / planLength) * 100}
                />
              </div>
              <div className="fw-bold">{femaleRatingData?.Neutral}</div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <div style={{ marginLeft: "3.85rem" }}>Satisfied:</div>
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+femaleRatingData?.Satisfied / planLength) * 100}
                />
              </div>
              <div className="fw-bold">{femaleRatingData?.Satisfied}</div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <div style={{ marginLeft: "1.3rem" }}>Very-Satisfied:</div>
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={
                    (+femaleRatingData?.["Very Satisfied"] / planLength) * 100
                  }
                />
              </div>
              <div className="fw-bold">
                {femaleRatingData?.["Very Satisfied"]}
              </div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <div style={{ marginLeft: "2.4rem" }}>Dissatisfied:</div>
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+femaleRatingData?.Dissatisfied / planLength) * 100}
                />
              </div>
              <div className="fw-bold">{femaleRatingData?.Dissatisfied}</div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <div>Very-Dissatisfied:</div>
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={
                    (+femaleRatingData?.["Very Dissatisfied"] / planLength) *
                    100
                  }
                />
              </div>
              <div className="fw-bold">
                {femaleRatingData?.["Very Dissatisfied"]}
              </div>
            </div>{" "}
          </div>
          <div className="w-50">
            <div className="d-flex flex-row align-items-center gap-2">
              <div className="fs-1" style={{ marginLeft: "2.45rem" }}>
                Using Traya Conditioner:
              </div>
              <div className="w-50 ms-2">
                <ProgressBar
                  animated={true}
                  now={
                    (+femaleRatingData?.traya_conditioner_Yes / planLength) *
                    100
                  }
                />
              </div>
              <div className="fs-1 fw-bold">
                {femaleRatingData?.traya_conditioner_Yes}
              </div>
            </div>
            <div className="d-flex flex-row gap-2 align-items-center">
              <div className="fs-1 ms-2">Not Using Traya Conditioner:</div>
              <div className="w-50 ms-1">
                <ProgressBar
                  animated={true}
                  variant="danger"
                  now={
                    (+femaleRatingData?.traya_conditioner_No / planLength) * 100
                  }
                />
              </div>
              <div className="fs-1 fw-bold">
                {femaleRatingData?.traya_conditioner_No}
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
}

export default FemaleSurveyPlan;
